import React from "react";
import Button from "../ui/Button";

const CallToAction = () => {
    return "";
    // <section className="py-20 relative overflow-hidden">
    //   {/* Background decorative elements */}
    //   <div className="absolute top-0 left-0 right-0 bottom-0 opacity-10">
    //     <div className="absolute -top-20 -left-20 w-64 h-64 bg-white rounded-full"></div>
    //     <div className="absolute top-40 right-20 w-32 h-32 bg-white rounded-full"></div>
    //   </div>

    //   <div className="container mx-auto relative z-10 bg-primary">
    //     <div className="max-w-3xl mx-auto text-center">
    //       <h2 className="heading-2 text-black mb-6">
    //         Unlock your new design team today.
    //       </h2>
    //       <p className="text-xl text-primary-400 mb-10 max-w-xl mx-auto">
    //         Collaborez avec notre équipe d'experts en design et développement pour transformer votre vision en réalité.
    //       </p>
    //       <Button
    //         variant="primary"
    //         className="text-lg px-8 py-4 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all"
    //       >
    //         Réserver une consultation gratuite
    //       </Button>
    //     </div>
    //   </div>
    // </section>
};

export default CallToAction;
